module.exports = __webpack_public_path__ + "static/media/afl-logo.652860a1.svg";